import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import EventCardTitle from '../../shared/event-card-title';
import { getEventDate } from '../../../utils/dateUtils';
import { useAppConfiguration } from '../../shared/hook';
import MentorAvatar from '../../shared/mentor-avatar';
import { OfferingContentProps } from './interface';
import ChipList from '../../shared/chip-list';

const OfferingContent = ({ upcomingEvent }: OfferingContentProps) => {
  const { t, i18n } = useTranslation();

  const classes = useStyles({ offeringType: upcomingEvent.type });
  const { withUnlimitedCredits } = useAppConfiguration();

  const eventDate = getEventDate(upcomingEvent.sessions[0].startsAt);
  const offeringLanguage = new Intl.DisplayNames([i18n.language], {
    type: 'language',
  });

  const sessionLabel = t('v2.global.label_session', {
    count: upcomingEvent.sessions.length,
  });

  const topicList = upcomingEvent.topics?.map((item: string) =>
    t(`v2.global.chip_label_topic_${item}`),
  );

  const creditLabel = !withUnlimitedCredits
    ? t('v2.global.label_credits', {
        count: upcomingEvent.price,
      })
    : '';

  return (
    <Box className={classes.content}>
      <EventCardTitle
        date={eventDate}
        duration={upcomingEvent.duration}
        name={upcomingEvent.name}
      />

      {!!upcomingEvent.topics.length && (
        <Box>
          <Typography className={classes.topicsLabel} variant="body2">
            {t('v2.global.label_topics')}
          </Typography>
          <ChipList list={topicList} style={{ margin: 0 }} />
        </Box>
      )}
      <Box>
        <Typography className={classes.topicsLabel} variant="body2">
          {t('v2.global.label_details')}
        </Typography>

        <ChipList
          list={[
            offeringLanguage.of(upcomingEvent.language) as string,
            sessionLabel,
          ]}
        />
        <ChipList list={[creditLabel]} />
      </Box>
      <MentorAvatar
        imageSrc={upcomingEvent?.mentor?.profileImage}
        name={upcomingEvent?.mentor?.name}
      />
    </Box>
  );
};

export default OfferingContent;
